<div class="top-right-absolute">
    <ion-button (click)="openLanguagesPopover($event)" size="small" fill="clear">
        <ion-img class="flag-svg"
            [src]="languageFlagUrl"
        ></ion-img>
    </ion-button>
</div>